import React, { lazy, useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark, FaFilePdf, FaImage } from "react-icons/fa6";
import { Button, CustomInput, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import { useGetAllCategoryQuery } from "../../Data/services/categoryApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import {
  useAddQuestionMutation,
  useUpdateQuestionMutation,
} from "../../Data/services/questionApi";
import DetailRow from "../CustomComponents/DetailRow";
import { MdCancel } from "react-icons/md";
import { FaCircleCheck } from "react-icons/fa6";
import { useUpdateShopMutation } from "../../Data/services/shopApi.js";
import ClipLoader from "react-spinners/ClipLoader.js";

const ZoomImage = lazy(() => import("../ZoomImage.js"));

// import {
//   addServiceMutation,
//   useUpdServiceMutation,
// } from "../../Data/services/businessTypeApi";

const ShopDetailsModal = ({ handleEditModalClose, editData, refetch }) => {
  console.log(editData);
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      question: editData ? editData.question : "",
      short_answer: editData ? editData.short_answer : "",
      points: editData ? editData.points : "",
    },
  });

  const [rowId, setRowId] = useState("");
  const [category, setCategory] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);

  const [categoryList, setCategoryList] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");

  // const {
  //   data: categoriesData,
  //   isSuccess,
  //   isLoading,
  //   isFetching,
  // } = useGetAllCategoryQuery(
  //   {
  //     limit: 1000,
  //     // page: currentPage,
  //   },
  //   { refetchOnMountOrArgChange: true }
  // );

  // useEffect(() => {
  //   if (isSuccess && categoriesData?.data) {
  //     // console.log(categoriesData.data);
  //     const tempList = categoriesData.data.map((item) => {
  //       // console.log(item); // If you want to log each item
  //       return {
  //         label: item.name.en,
  //         value: item.id,
  //       };
  //     });

  //     // console.log(tempList);

  //     setCategoryList(tempList);
  //   }
  // }, [categoriesData, isSuccess]);

  // const questionTypes = [
  //   {
  //     id: 10,
  //     name: "Easy",
  //   },
  //   {
  //     id: 30,
  //     name: "Medium",
  //   },
  //   {
  //     id: 50,
  //     name: "Hard",
  //   },
  // ];

  // const categoryList = categoriesData.data.map((item) => ({
  //   label: item.name,
  //   value: item.id,
  // }));

  // const questionTypeList = questionTypes.map((item) => ({
  //   label: item.name,
  //   value: item.id,
  // }));

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
    }
  }, [editData]);

  const handleBusinessTitle = (e) => {
    // console.log(e.target.value);
    setCategory(e.target.value);
  };

  // const handleImage = (e) => {
  //   console.log(e.target.files[0]);
  //   setImage(e.target.files[0]);
  // };

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // console.log(errors);

  const [updateShop, { isLoading: updating }] = useUpdateShopMutation();

  const handleSendData = async (data) => {
    console.log(rowId);
    console.log(data);
    // return;
    setSending(true);

    try {
      let response;
      if (editData) {
        response = await updateShop({ data, id: rowId }).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer} style={{ maxWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">{"Shop Details"}</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <Row className="w-100">
            <Col md={6} sm={12}>
              <div className="text-center">
                <img
                  style={{ aspectRatio: 1 }}
                  alt=""
                  src={editData?.image_url}
                  className="rounded-circle mb-3"
                  width={"100px"}
                />
              </div>
              <DetailRow title={"Name"} value={editData?.name} />
              <DetailRow title={"Email"} value={editData?.email} />
              <DetailRow title={"Phone"} value={editData?.mobile_no} />
              <DetailRow title={"Address"} value={editData?.address} />
              <DetailRow title={"City"} value={editData?.city} />
              <DetailRow title={"State"} value={editData?.state} />
              <DetailRow title={"Country"} value={editData?.country} />
              <DetailRow title={"Postal Code"} value={editData?.postal_code} />
              <DetailRow
                title={"Status"}
                value={
                  editData?.is_blocked ? (
                    <div className="d-flex justify-content-center align-items-center gap-2 ">
                      <MdCancel color="red" />
                      Blocked
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center gap-2 ">
                      <FaCircleCheck color="green" />
                      Active
                    </div>
                  )
                }
              />

              <DetailRow
                title={"Shop Category"}
                value={editData?.shop_details?.shop_category?.name}
              />
              <DetailRow
                title={"Shop Sub Category"}
                value={editData?.shop_details?.shop_sub_category?.name}
              />
            </Col>

            <Col md={6} sm={12}>
              {updating ? (
                <div className="d-flex justify-content-center p-2">
                  <ClipLoader color="#0f0f0f" size="22px" />
                </div>
              ) : (
                <Row className={`w-100`}>
                  <>
                    <Col md={6} sm={12}>
                      <Button
                        classes={`bg-danger mb-2 ${
                          editData.shop_details?.status === 30 ? "d-none" : ""
                        }`}
                        type="submit"
                        text={
                          sending ? (
                            <Spinner
                              animation="grow"
                              size="sm"
                              className="mx-3 my-1"
                            />
                          ) : (
                            "Reject"
                          )
                        }
                        onClick={() => {
                          handleSendData({ status: 30 /* 30 for rejected */ });
                        }}
                      />
                    </Col>
                    <Col md={6} sm={12}>
                      <Button
                        classes={` mb-2 ${
                          editData.shop_details?.status === 20 ? "d-none" : ""
                        }`}
                        type="submit"
                        text={
                          sending ? (
                            <Spinner
                              animation="grow"
                              size="sm"
                              className="mx-3 my-1"
                            />
                          ) : (
                            "Accept"
                          )
                        }
                        onClick={() => {
                          handleSendData({ status: 20 /* 20 for rejected */ });
                        }}
                      />
                    </Col>
                  </>
                </Row>
              )}

              <br></br>

              <p className=" fw-bold">Documents:</p>
              {editData?.shop_documents?.map((link, index) => (
                <div key={index} className="mb-2">
                  <a
                    href={link.media_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-primary"
                  >
                    {link.media_type === "image" ? (
                      <FaImage size={40} />
                    ) : link.media_type === "pdf" ? (
                      <FaFilePdf size={40} />
                    ) : (
                      "Other Document"
                    )}
                  </a>
                </div>
              ))}
              <p className=" fw-bold">Social Links:</p>
              {editData?.shop_details?.social_links?.map((link, index) => (
                <div key={index} className="mb-2">
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-primary"
                  >
                    {link.platform}
                  </a>
                </div>
              ))}
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ShopDetailsModal;
